export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'Phone'
  ],
  'requiredFields': {
    'default': [
      'Company',
      'PostalCode'
    ],
    'consulting': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'offersInvestment': [
      'PostalCode'
    ],
    'other': [],
    'customer_serviceGeneral': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ],
    'customer_serviceBank': [
      'RequestTopic'
    ],
    'career': [],
    'press': [],
    'cooperation': [
      'Company',
      'PostalCode',
      'RequestTopic'
    ]
  },
}
